import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _Object$entries from "@babel/runtime-corejs3/core-js/object/entries";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import GenericModal from "@Shared/components/modals/generic-modal.vue";
import FileManagementMixin from "@Shared/utils/application-mixins/file-management-mixin";
import * as DocumentsActions from "@Broker/@Modules/clients/applications/documents/store/documents-actions";
import * as ApplicationGetters from "@Broker/@Modules/clients/applications/application/store/application-getters";
import * as ApplicationActions from "@Broker/@Modules/clients/applications/application/store/application-actions";
import * as ApplicationMutations from "@Broker/@Modules/clients/applications/application/store/application-mutations";
import { defineComponent, toRefs, ref, computed, watch } from "@vue/composition-api";
import { createNamespacedHelpers } from "vuex-composition-helpers";
import Select2 from "@Shared/components/inputs/select2.vue";
import { useI18n } from "vue-i18n-composable";
import SelectSection from "@Shared/components/sections/select-section.vue";
import { isEmpty, mapValues, cloneDeep, get, set, isNil, omit, find, size, sortBy, kebabCase, camelCase, random } from "lodash";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { APPLICATION_FIELD_OPTIONS } from "@Shared/@Utils/application-defaults-utils/global-field-options";
import { formatIntegerQuantity, formatMoneyValueLong } from "@Shared/@Utils/helpers/money";
import numeral from "numeral";
import TextField from "@Shared/components/form-elements/fields/text-field.vue";
import CurrencyField from "@Shared/components/form-elements/fields/currency-field.vue";
import NumberField from "@Shared/components/form-elements/fields/number-field.vue";
import PercentageField from "@Shared/components/form-elements/fields/percentage-field.vue";
import SinField from "@Shared/components/form-elements/fields/sin-field.vue";
import { DOCUMENT_CLASSIFICATIONS, DOCUMENT_CLASSIFICATIONS_FR } from "@Shared/@Utils/constants";
import { delay, removeEmptyKeys } from "@Shared/@Utils/utils";
import SelectScreenItem from "./document-extraction/select-screen-item.vue";
import { EMPTY_JOB, failover, findLabel, flattenObject, fullName, getLastPartOfKey, HEADER, NEW_JOB, payPeriods, sentenceCase, titleCaseKey } from "./document-extraction/document-extraction-utils";
export default defineComponent({
  name: "DocumentExtractionModal",
  components: {
    GenericModal,
    Select2,
    SelectSection,
    SimpleButton,
    TextField,
    CurrencyField,
    NumberField,
    PercentageField,
    SinField,
    SelectScreenItem
  },
  mixins: [FileManagementMixin],
  props: {
    fileName: {
      type: String,
      default: ""
    },
    clientUsername: {
      type: String,
      required: true
    },
    applicationId: {
      type: [String, Number],
      default: ""
    },
    documentId: {
      type: String,
      default: ""
    },
    documentType: {
      type: String,
      default: ""
    },
    modalDialogSize: {
      type: String,
      default: "lg"
    }
  },
  setup(props) {
    const {
      useActions: useDocumentStoreActions,
      useState: useDocumentStoreState
    } = createNamespacedHelpers("DocumentsStore");
    const {
      useGetters: useApplicationStoreGetters,
      useActions: useApplicationStoreActions,
      useMutations: useApplicationStoreMutations
    } = createNamespacedHelpers("ApplicationStore");
    const {
      EXTRACT_DOCUMENT_VALUES,
      DOWNLOAD_DOCUMENT,
      UPDATE_EXTRACTED_DOCUMENT_VALUES
    } = useDocumentStoreActions([DocumentsActions.EXTRACT_DOCUMENT_VALUES, DocumentsActions.DOWNLOAD_DOCUMENT, DocumentsActions.UPDATE_EXTRACTED_DOCUMENT_VALUES]);
    const {
      extractedDocumentValues
    } = useDocumentStoreState(["extractedDocumentValues"]);
    const {
      CURRENT_APPLICATION
    } = useApplicationStoreGetters([ApplicationGetters.CURRENT_APPLICATION]);
    const {
      SAVE_CURRENT_APPLICATION
    } = useApplicationStoreActions([ApplicationActions.SAVE_CURRENT_APPLICATION]);
    const {
      UPDATE_APPLICATION_DETAILS
    } = useApplicationStoreMutations([ApplicationMutations.UPDATE_APPLICATION_DETAILS]);
    const {
      fileName,
      clientUsername,
      applicationId,
      documentId,
      documentType
    } = toRefs(props);
    let FORMAT;
    (function (FORMAT) {
      FORMAT[FORMAT["INTEGER"] = 0] = "INTEGER";
      FORMAT[FORMAT["MONEY"] = 1] = "MONEY";
      FORMAT[FORMAT["PERCENT"] = 2] = "PERCENT";
      FORMAT[FORMAT["SIN"] = 3] = "SIN";
      FORMAT[FORMAT["NONE"] = 4] = "NONE";
    })(FORMAT || (FORMAT = {}));
    const {
      t,
      te
    } = useI18n();
    const tr = s => t(s).toString();
    const applicantSelectOptions = {
      closeOnSelect: true,
      placeholder: t("application-form.applicant"),
      minimumResultsForSearch: -1
    };
    const jobSelectOptions = {
      closeOnSelect: true,
      placeholder: t("document-extraction.employmentRecord"),
      minimumResultsForSearch: -1
    };
    const isMLS = documentType.value === DOCUMENT_CLASSIFICATIONS["mls-listing"] || documentType.value === DOCUMENT_CLASSIFICATIONS_FR["mls-listing"];
    const table = {
      columns: ["key", "currentValue", "suggestedValue", "selected"],
      options: {
        skin: "table table-hover",
        filterable: false,
        perPage: 999999,
        perPageValues: [999999],
        showChildRowToggler: false,
        tabbable: false,
        pagination: {
          show: false
        },
        sortable: [],
        headings: {
          key: t("document-extraction.field"),
          currentValue: t("document-extraction.currentApplicationValue"),
          suggestedValue: t("document-extraction.suggestedValue")
        },
        texts: {
          noResults: isMLS ? t("document-extraction.loading") : t("document-extraction.selectApplicant")
        },
        columnsClasses: {
          key: "w-30",
          currentValue: "w-30",
          suggestedValue: "w-30"
        },
        selectable: {
          mode: "multiple",
          selectAllMode: "all",
          programatic: false,
          only: ({
            isHeader
          }) => !isHeader,
          programmatic: true
        }
      }
    };
    const {
      applicantIncomePeriodOptions,
      applicantIncomeTypeOptions,
      applicantEmploymentTypeOptions,
      applicantOccupationOptions,
      applicantIndustrySectorOptions,
      propertyUnitOfMeasurementOptions,
      propertyTypeOptions,
      propertyStyleOptions,
      propertyConstructionTypeOptions,
      propertyGarageSizeOptions,
      propertySewageTypeOptions,
      propertyWaterInfoOptions,
      propertyHeatingTypeOptions,
      canadaProvinceOptions
    } = APPLICATION_FIELD_OPTIONS();
    const hasCoapplicant = () => !isEmpty(removeEmptyKeys({
      applicant: CURRENT_APPLICATION.value["co-applicants"]
    }));
    const possibleValues = {
      default: [],
      "income-period": applicantIncomePeriodOptions,
      "income-type": applicantIncomeTypeOptions,
      "employment-type": applicantEmploymentTypeOptions,
      occupation: applicantOccupationOptions,
      "industry-sector": applicantIndustrySectorOptions,
      "lot-size-type": propertyUnitOfMeasurementOptions,
      "property-type": propertyTypeOptions,
      "property-style": propertyStyleOptions,
      "construction-type": propertyConstructionTypeOptions,
      "garage-size": propertyGarageSizeOptions,
      "sewage-info": propertySewageTypeOptions,
      "water-info": propertyWaterInfoOptions,
      heat: propertyHeatingTypeOptions,
      province: canadaProvinceOptions
    };
    const order = (() => {
      const addressFields = ["line1", "line2", "unit-number", "street-number", "street-name", "street-type", "street-direction", "city", "province", "postal-code"];
      const nameFields = ["first-name", "middle-name", "last-name"];
      const generateFields = (prefix, fields) => {
        var _context;
        return _mapInstanceProperty(_context = ["", ...fields]).call(_context, field => field ? `${prefix}.${field}` : prefix);
      };
      return ["employer-name", "job-title", ...generateFields("employee-name", nameFields), ...generateFields("employer-address", addressFields), ...generateFields("subject-property-address", addressFields), "income-type", "income-period", "income-amount"];
    })();
    const keyNames = {
      line1: t("global.doorr.addressLine1"),
      line2: t("global.doorr.addressLine2"),
      "living-space": t("application-form.property-size-sq-ft"),
      "sewage-info": t("application-form.sewage-type"),
      "water-info": t("application-form.water-information"),
      heat: t("application-form.heating-type"),
      "structure-age": t("application-form.structure-age-in-years"),
      sin: t("application-form.social-insurance-number"),
      "lot-size-type": t("application-form.unit-of-measurement"),
      "work-phone": t("application-form.work-phone-number")
    };
    const formats = {
      "income-amount": FORMAT.MONEY,
      "property-taxes": FORMAT.MONEY,
      "lot-size": FORMAT.INTEGER,
      "living-space": FORMAT.INTEGER,
      sin: FORMAT.SIN
    };
    const extractedValues = computed({
      get() {
        return extractedDocumentValues.value.byId[documentId.value];
      },
      set(value) {
        UPDATE_EXTRACTED_DOCUMENT_VALUES({
          result: value,
          documentId: documentId.value
        });
      }
    });
    const tableRef = ref(null);
    const applicants = computed(() => [CURRENT_APPLICATION.value["main-applicant"], ...(hasCoapplicant() ? CURRENT_APPLICATION.value["co-applicants"] : [])]);
    const currentApplicant = ref(applicants.value.length > 1 ? -1 : 0);
    const currentJob = ref(-1);
    const isLoadingPDF = ref(false);
    const previewDocumentUrl = ref("");
    const isNewJob = ref(false);
    const modal = ref();
    const modalBody = ref();
    const previewChanges = ref(false);
    const changesClone = ref([]);
    const suggestedValues = ref({});
    const selectedRows = ref({});
    const annualIncome = ref(0);
    const isSaving = ref(false);
    const savingComplete = ref(false);
    const loadingProgress = ref(0);
    const showSelectScreen = ref(false);
    const hasErrors = ref(false);
    const pullData = async () => {
      var _context2, _context3;
      reset();
      simulateProgressBar();
      const documentKey = _findInstanceProperty(_context2 = _mapInstanceProperty(_context3 = [DOCUMENT_CLASSIFICATIONS, DOCUMENT_CLASSIFICATIONS_FR]).call(_context3, d => {
        var _context4;
        return _findInstanceProperty(_context4 = _Object$keys(d)).call(_context4, k => k in d && d[k] === documentType.value);
      })).call(_context2, Boolean);
      try {
        await EXTRACT_DOCUMENT_VALUES({
          clientUsername: clientUsername.value,
          applicationId: applicationId.value,
          fileName: fileName.value,
          documentId: documentId.value,
          documentType: documentKey
        });
      } catch (_) {}
    };
    const applicantJobs = computed(() => {
      var _applicants$value$cur, _applicants$value$cur2;
      const jobs = (_applicants$value$cur = (_applicants$value$cur2 = applicants.value[currentApplicant.value]) == null ? void 0 : _applicants$value$cur2.employment) != null ? _applicants$value$cur : [];
      const firstEmptyJobIndex = _findIndexInstanceProperty(jobs).call(jobs, item => item["employer-name"] === "" && item["job-title"] === "");
      const functions = (() => {
        if (firstEmptyJobIndex !== -1) return {
          [EMPTY_JOB]: firstEmptyJobIndex
        };
        return {
          [NEW_JOB]: NEW_JOB
        };
      })();
      return [...jobs, functions];
    });
    const tableRows = computed(() => {
      var _context5;
      if (currentJob.value < 0 || isEmpty(extractedValues.value)) return [];
      const warnings = get(extractedValues.value, ["warnings"], {});
      const valuesWithoutWarnings = omit(extractedValues.value, ["warnings"]);
      const newEmployerValues = omit((isNewJob.value || getApplicationValue("employer-name") === "") && !isMLS ? {
        "employer-name": "",
        "job-title": ""
      } : {}, _Object$keys(valuesWithoutWarnings));
      const combinedValues = flattenObject(_objectSpread(_objectSpread({}, newEmployerValues), valuesWithoutWarnings));
      const finalValues = _mapInstanceProperty(_context5 = _Object$entries(combinedValues)).call(_context5, ([key, value], index) => {
        var _formats$getLastPartO;
        return {
          id: index,
          key,
          currentValue: getApplicationValue(key),
          suggestedValue: value,
          possibleValues: getPossibleValues(key),
          isHeader: value === HEADER,
          isSubsection: _includesInstanceProperty(key).call(key, "."),
          selected: false,
          warning: warnings[getLastPartOfKey(key)],
          format: (_formats$getLastPartO = formats[getLastPartOfKey(key)]) != null ? _formats$getLastPartO : FORMAT.NONE
        };
      });
      const sortedValues = sortBy(finalValues, [item => {
        const index = _indexOfInstanceProperty(order).call(order, item.key);
        return index === -1 ? Infinity : index;
      }]);
      return sortedValues;
    });
    const getSelectedRows = computed(() => {
      var _tableRef$value$filte, _tableRef$value, _tableRef$value$filte2, _context6;
      return (_tableRef$value$filte = tableRef == null ? void 0 : (_tableRef$value = tableRef.value) == null ? void 0 : (_tableRef$value$filte2 = _tableRef$value.filteredData) == null ? void 0 : _mapInstanceProperty(_context6 = _filterInstanceProperty(_tableRef$value$filte2).call(_tableRef$value$filte2, row => !row.isHeader && selectedRows.value[row.key])).call(_context6, row => _objectSpread(_objectSpread({}, row), {}, {
        suggestedValue: suggestedValues.value[row.key]
      }))) != null ? _tableRef$value$filte : [];
    });
    const changes = computed(() => ({
      items: getSelectedRows.value,
      fields: [{
        key: "key",
        label: t("document-extraction.field")
      }, {
        key: "currentValue",
        label: t("document-extraction.currentApplicationValue")
      }, {
        key: "suggestedValue",
        label: t("document-extraction.suggestedValue")
      }]
    }));
    const allRowsSelected = computed({
      get() {
        return size(getSelectedRows.value) > 0 && size(getSelectedRows.value) === size(selectedRows.value);
      },
      set(newValue) {
        toggleAllSelected(newValue);
      }
    });
    const someRowsSelected = computed(() => {
      var _getSelectedRows$valu;
      return !allRowsSelected.value && ((_getSelectedRows$valu = getSelectedRows.value) == null ? void 0 : _getSelectedRows$valu.length) > 0;
    });
    const currentApplicantTitle = computed(() => {
      var _applicants$value$cur3;
      const {
        "employer-name": employer,
        "job-title": job
      } = (_applicants$value$cur3 = applicants.value[currentApplicant.value]["employment"][currentJob.value]) != null ? _applicants$value$cur3 : isNewJob.value;
      if (isMLS) return t("global.doorr.subjectProperty");
      if (isNil(employer) || isNil(job)) return "";
      return `${employer} - ${job}`;
    });
    const currentApplicantPath = computed(() => +currentApplicant.value === 0 ? `main-applicant` : `co-applicants[${currentApplicant.value - 1}]`);
    const isLoaded = computed(() => loadingProgress.value >= 100);
    const loadingProgressCurve = computed(() => {
      const x = loadingProgress.value / 100;
      return Math.sqrt(1 - Math.pow(x - 1, 2)) * 100;
    });
    const handlePreviewChanges = value => {
      previewChanges.value = value;
      modalBody.value.scrollTop = 0;
    };
    const handleApplyValues = async () => {
      isSaving.value = true;
      const app = cloneDeep(CURRENT_APPLICATION.value);
      changesClone.value = cloneDeep(changes.value.items);
      changes.value.items.forEach(({
        key,
        suggestedValue
      }) => set(app, getValuePath(key), suggestedValue));
      const touchesEmployment = changes.value.items.some(({
        key
      }) => {
        var _context7;
        return _includesInstanceProperty(_context7 = getValuePath(key)).call(_context7, "employment");
      });
      if (touchesEmployment) {
        set(app, getValuePath("current-job"), true);
      }
      UPDATE_APPLICATION_DETAILS(_objectSpread({
        applicationId: applicationId.value
      }, app));
      const DO_SAVE = true;
      if (DO_SAVE) await SAVE_CURRENT_APPLICATION({
        applicationId: applicationId.value,
        clientUsername: clientUsername.value
      });else await delay(2000);
      isSaving.value = false;
      savingComplete.value = true;
      await delay(2000);
      await hide();
      previewChanges.value = false;
      savingComplete.value = false;
    };
    const handleApplicantChange = ({
      id
    }) => {
      currentApplicant.value = id;
      currentJob.value = -1;
      isNewJob.value = false;
    };
    const handleJobChange = ({
      id,
      value
    }) => {
      isNewJob.value = value === NEW_JOB;
      currentJob.value = id;
    };
    const toggleAllSelected = checked => {
      selectedRows.value = mapValues(selectedRows.value, () => checked);
    };
    const handleViewPDF = async () => {
      if (!previewDocumentUrl.value) {
        isLoadingPDF.value = true;
        const {
          url
        } = await DOWNLOAD_DOCUMENT({
          clientUsername: clientUsername.value,
          applicationId: applicationId.value,
          fileName: fileName.value,
          documentId: documentId.value
        });
        previewDocumentUrl.value = encodeURIComponent(url);
        await delay(750);
        isLoadingPDF.value = false;
      }
      window.open(`https://docs.google.com/gview?embedded=false&url=${previewDocumentUrl.value}`, "_blank");
    };
    const hide = async () => {
      modal.value.hide();
      await delay(750);
      reset();
    };
    const closeSelectScreen = () => {
      showSelectScreen.value = false;
    };
    const formatApplicantData = data => data == null ? void 0 : _mapInstanceProperty(data).call(data, (item, index) => {
      const pd = item["personal-details"];
      return {
        text: fullName(pd),
        value: index,
        id: index
      };
    });
    const formatJobData = data => {
      var _context8;
      return data == null ? void 0 : _filterInstanceProperty(_context8 = _mapInstanceProperty(data).call(data, (item, index) => {
        if (NEW_JOB in item) {
          return {
            text: t("document-extraction.newEmploymentRecord"),
            value: item[NEW_JOB],
            id: index
          };
        }
        if (EMPTY_JOB in item) {
          return {
            text: t("document-extraction.newEmploymentRecord"),
            value: item[EMPTY_JOB],
            id: item[EMPTY_JOB]
          };
        }
        if (item["employer-name"] === "" && item["job-title"] === "") {
          return null;
        }
        return {
          text: `${item["employer-name"]} - ${item["job-title"]}`,
          value: index,
          id: index
        };
      })).call(_context8, x => x);
    };
    const autoSelectApplicant = extractedName => {
      var _context9;
      const matchingApplicantIndex = _findIndexInstanceProperty(_context9 = applicants.value).call(_context9, e => fullName(e["personal-details"]).toLowerCase() === extractedName);
      if (matchingApplicantIndex >= 0 && currentApplicant.value === -1) handleApplicantChange({
        id: matchingApplicantIndex
      });
    };
    const getValuePath = key => {
      const applicant = currentApplicantPath.value;
      const personal = `${applicant}.personal-details`;
      const job = `${applicant}.employment[${currentJob.value}]`;
      const property = "property";
      const parts = key.split(".");
      if (parts.length === 1) {
        switch (key) {
          case "employer-name":
          case "job-title":
          case "income-period":
          case "income-amount":
          case "income-type":
          case "employment-type":
          case "work-phone":
          case "time-at-job":
          case "occupation":
          case "industry-sector":
          case "current-job":
            return `${job}.${key}`;
          case "sin":
            return `${personal}.sin`;
        }
      } else {
        const [header, value] = parts;
        switch (header) {
          case "employer-address":
            return `${job}.address.${value}`;
          case "client-address":
            return `${personal}.addresses[0].${value}`;
          case "employee-name":
            return `${personal}.${value}`;
          case "sin":
            return `${personal}.sin.${value}`;
          case "property-details":
            switch (value) {
              case "living-space":
                return `${property}.${value}`;
              default:
                return `${property}.styles.${value}`;
            }
          case "taxes":
            switch (value) {
              case "property-taxes":
                return `${property}.costs.${value}`;
              case "tax-year":
                return `${property}.costs.${value}`;
              default:
                return `${property}.costs.${value}`;
            }
          case "subject-property-address":
            switch (value) {
              default:
                return `${property}.details.address.${value}`;
            }
        }
      }
      return "";
    };
    const getApplicationValue = key => {
      const application = CURRENT_APPLICATION.value;
      if (key === "sin") {
        return get(application, getValuePath(key));
      }
      return String(get(application, getValuePath(key), ""));
    };
    const getPossibleValues = fullKey => {
      var _find;
      return (_find = find(possibleValues, (_, key) => _includesInstanceProperty(fullKey).call(fullKey, key))) != null ? _find : possibleValues["default"];
    };
    const getKeyName = key => {
      var _context0, _ref, _keyNames$lastPart;
      const lastPart = getLastPartOfKey(key);
      const translationKey = _findInstanceProperty(_context0 = [`document-extraction.${camelCase(lastPart)}`, `application-form.${kebabCase(lastPart)}`, `global.words.${camelCase(lastPart)}`, `global.doorr.${camelCase(lastPart)}`]).call(_context0, key => te(key));
      return (_ref = (_keyNames$lastPart = keyNames[lastPart]) != null ? _keyNames$lastPart : translationKey && t(translationKey)) != null ? _ref : `[FR]${titleCaseKey(key)}[FR]`;
    };
    const reset = () => {
      toggleAllSelected(false);
      isNewJob.value = false;
      currentJob.value = -1;
      suggestedValues.value = {};
      loadingProgress.value = 0;
      closeSelectScreen();
    };
    const formatValue = (value, {
      format,
      possibleValues
    }) => {
      if (value === null || value === "null") return "";
      if (typeof value === "string" && (value === "" || isNaN(Number(value)))) return findLabel(possibleValues, value);
      if (format === FORMAT.SIN) value = value;
      const result = {
        [FORMAT.MONEY]: formatMoneyValueLong(value),
        [FORMAT.INTEGER]: formatIntegerQuantity(value),
        [FORMAT.PERCENT]: numeral(value).format("0.000%"),
        [FORMAT.SIN]: typeof value === "object" ? `${value["1"]}-${value["2"]}-${value["3"]}` : "",
        [FORMAT.NONE]: value
      }[format];
      return result;
    };
    const getInputComponent = ({
      format
    }) => ({
      [FORMAT.MONEY]: "currency-field",
      [FORMAT.INTEGER]: "number-field",
      [FORMAT.PERCENT]: "percentage-field",
      [FORMAT.SIN]: "sin-field",
      [FORMAT.NONE]: "text-field"
    })[format];
    const simulateProgressBar = async (setToMax = false) => {
      const INCREASE = 0.3;
      if (setToMax) {
        loadingProgress.value = 99.9;
        await delay(500);
        loadingProgress.value = 100;
        return;
      }
      loadingProgress.value += INCREASE;
      const progressBarUpdate = setInterval(() => {
        if (loadingProgress.value >= 99.9) {
          clearInterval(progressBarUpdate);
          return;
        }
        if (loadingProgress.value < 98) loadingProgress.value += INCREASE;
      }, random(1000, 2000));
    };
    const getPayPeriod = s => {
      var _payPeriods$s;
      return (_payPeriods$s = payPeriods == null ? void 0 : payPeriods[s]) != null ? _payPeriods$s : payPeriods["annual"];
    };
    watch(extractedValues, async () => {
      if (isLoaded.value) return;
      hasErrors.value = "error" in extractedValues.value;
      if (extractedValues.value) {
        await simulateProgressBar(true);
        if ("employee-name" in extractedValues.value) autoSelectApplicant(fullName(extractedValues.value["employee-name"]).toLowerCase());
        if (isMLS) {
          currentApplicant.value = 0;
          currentJob.value = 0;
        }
      } else {
        previewChanges.value = false;
        await hide();
      }
      await simulateProgressBar(true);
      if (!isMLS) showSelectScreen.value = true;
    });
    watch(tableRows, newValue => {
      var _context1;
      if (!isEmpty(suggestedValues.value) || isEmpty(newValue)) return;
      const newEmployerValues = [{
        key: "employer-name",
        suggestedValue: t("document-extraction.newEmployerSuggestion")
      }, {
        key: "job-title",
        suggestedValue: t("document-extraction.newJobSuggestion")
      }];
      suggestedValues.value = _reduceInstanceProperty(_context1 = [...newEmployerValues, ...newValue]).call(_context1, (acc, {
        key,
        suggestedValue
      }) => _objectSpread(_objectSpread({}, acc), {}, {
        [key]: suggestedValue
      }), {});
    });
    watch(tableRows, newValue => {
      var _context10;
      selectedRows.value = _reduceInstanceProperty(_context10 = _filterInstanceProperty(newValue).call(newValue, ({
        isHeader
      }) => !isHeader)).call(_context10, (acc, {
        key
      }) => _objectSpread(_objectSpread({}, acc), {}, {
        [key]: false
      }), {});
    });
    watch(() => suggestedValues.value["income-amount"], newValue => {
      if (isNil(newValue)) return;
      annualIncome.value = newValue * getPayPeriod(suggestedValues.value["income-period"]);
    });
    watch(() => suggestedValues.value["income-period"], (newValue, oldValue) => {
      if (isNil(oldValue) || isNil(newValue) || isNil(annualIncome.value)) return;
      suggestedValues.value["income-amount"] = annualIncome.value / getPayPeriod(newValue);
    });
    return {
      table,
      tableRows,
      handleApplyValues,
      applicants,
      applicantSelectOptions,
      currentApplicant,
      handleApplicantChange,
      formatApplicantData,
      currentJob,
      handleJobChange,
      applicantJobs,
      jobSelectOptions,
      formatJobData,
      pullData,
      handleViewPDF,
      tableRef,
      modal,
      modalBody,
      hide,
      handlePreviewChanges,
      changes,
      previewChanges,
      allRowsSelected,
      someRowsSelected,
      suggestedValues,
      toggleAllSelected,
      selectedRows,
      getSelectedRows,
      currentApplicantTitle,
      isLoadingPDF,
      isSaving,
      getKeyName,
      savingComplete,
      changesClone,
      failover,
      sentenceCase,
      formatValue,
      getInputComponent,
      isMLS,
      loadingProgressCurve,
      isLoaded,
      showSelectScreen,
      closeSelectScreen,
      tr,
      hasErrors
    };
  }
});